import SwoopHeaders from 'web-client/utils/swoopHeaders'

let _token: string | null = null

interface ApiType {
  GET: string
  POST: string
  DELETE: string
  UPDATE: string
  setup: boolean
  getBearerToken: () => string | null
  setBearerToken: (token: string) => void
}

const Api: ApiType = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
  UPDATE: 'PATCH',
  setup: false,
  getBearerToken() {
    return _token
  },
  setBearerToken(token: string) {
    this.setup = true
    _token = token
    SwoopHeaders.setBearerToken(token)
  },
}

export default Api
